import React, {FC} from 'react';
import {Nav, Navbar} from 'react-bootstrap/cjs';

import styles from './MenuContainer.module.css';
import {useState} from '../../state/store';
import {config} from '../../state/config';
import {Page} from '../../state/types';

interface MenuContainerProps {
    isPromotionActive: any;
}

const MenuContainer: FC<MenuContainerProps> = ({isPromotionActive}) => {
    const {page} = useState('page');
    if (isPromotionActive === null) {
        return (
            <div></div>
        );
    }

    if (isPromotionActive) {
        return (
            <Navbar expand="lg" className={styles.MenuContainer}>
                <Navbar.Brand href="#">
                    <img src={`${config.publicUrl}/img/home-icon.png`} alt="Home" width={30}/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link active={page === Page.HowItWorks} href={`#${Page.HowItWorks}`}>
                            How it Works
                        </Nav.Link>
                        <Nav.Link active={page === Page.QualifyingDevices} href={`#${Page.QualifyingDevices}`}>
                            Qualifying Devices
                        </Nav.Link>
                        <Nav.Link active={page === Page.ContactUs} href={`#${Page.ContactUs}`}>
                            Contact Us
                        </Nav.Link>
                        <Nav.Link active={page === Page.FAQ} href={`#${Page.FAQ}`}>
                            FAQ
                        </Nav.Link>
                        {/*<Nav.Link active={page === Page.TermsAndConditions} href={`#${Page.TermsAndConditions}`}>*/}
                        {/*    Terms and Conditions*/}
                        {/*</Nav.Link>*/}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>

        );
    }

    return (
        <Navbar expand="lg" className={styles.MenuContainer}>
            <Navbar.Brand href="#">
                <img src={`${config.publicUrl}/img/home-icon.png`} alt="Home" width={30}/>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Nav.Link active={page === Page.FAQ} href={`#${Page.FAQ}`}>
                        FAQ
                    </Nav.Link>
                    {/*<Nav.Link active={page === Page.TermsAndConditions} href={`#${Page.TermsAndConditions}`}>*/}
                    {/*    Terms and Conditions*/}
                    {/*</Nav.Link>*/}
                    <Nav.Link active={page === Page.ContactUs} href={`#${Page.ContactUs}`}>
                        Contact Us
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default MenuContainer;